const SELECTOR_PRODUCT_FORM = '[data-product-form]';
const SELECTOR_SUBSCRIPTION = '[data-product-subscription-options]';
const SELECTOR_OPTION = '[data-subscription-option-radio]';
const SELECTOR_FREQUENCY_SELECT = '[data-frequency-select]';

/**
 * 
 * @param {HTMLButton} btn button that triggered add to cart event
 * @returns {} subscriptionProperties - used when adding reCharge prod to cart
 */
export function getSubscriptionProperties(btn : EventTarget | null) {
  const productForm = getProductForm(btn);
  const subscriptionElement = productForm?.querySelector(SELECTOR_SUBSCRIPTION);
  if(!productForm || !subscriptionElement) return false;

  const option = subscriptionElement.querySelector(`${SELECTOR_OPTION}:checked`);
  if(!option || option.value === 'onetime') return false;

  const frequencySelect = subscriptionElement.querySelector(SELECTOR_FREQUENCY_SELECT);
  if(!frequencySelect.value) return false;

  return {
    selected_selling_plan: parseInt(frequencySelect.value)
  }
}

export function getSubscriptionName(btn : EventTarget | null){
  const productForm = getProductForm(btn);
  const subscriptionElement = productForm?.querySelector(SELECTOR_SUBSCRIPTION);
  if(!productForm || !subscriptionElement) return false;

  const frequencySelect = subscriptionElement.querySelector(SELECTOR_FREQUENCY_SELECT);
  if(!frequencySelect.value) return false;

  return {
    selected_plan_name : frequencySelect.options[frequencySelect.selectedIndex].text
  }
}

function getProductForm(btn :any) {
  return btn.closest(SELECTOR_PRODUCT_FORM);
}